<template>
    <div class="vue-ttext">
        <textarea v-html="textVal" class="ttext" :maxlength="num" :name="name" :readonly="readonly" @input="input" v-validate="validate" :placeholder="placeholder"></textarea>
        <!--<div v-html="textVal"></div>-->
        <div class="err">
            <span v-show="(flag || errors.has(name))&& !readonly">{{errors.first(name)}}</span>
        </div>
        <div class="num_wrap"><span>{{now}}</span>/{{totalNum}}</div>
    </div>
</template>
<script>
	export default {
	    name: 'textarea',
	    props:{
            value: {
                default:''
            },
            num: {
                type: Number,
                required: true
            },
            placeholder:{
                type: String,
                default:''
            },
            name:{
                default:''
            },
            validate:{
                default:''
            },
            'html':{
                default:false
            },
            'readonly':{
                default:false
            }
        },
	    data(){
	        return{
                now: 0,
                totalNum : this.num,
                flag: false,
//                textVal : this.value
            }
        },
        computed:{
            textVal(){
                return this.value
            }
        },
        watch: {
            value(){
                if(typeof this.value === 'string'){
                    this.now = this.value.length;
                }
            }
        },
        mounted(){
        },
        methods:{
            validateChild(){
                this.$validator.validateAll();
                if (this.errors.any()) {
                    this.flag = true;
                    this.$emit('errorsChanged', false)
                }else {
                    this.flag = false;
                    this.$emit('errorsChanged', true)
                }
            },
            input(e){
                this.now = e.target.value.length;
                this.$emit('input', e.target.value.trim());
            }
        }
    }
</script>
<style lang="scss" type="text/scss" scoped>
	.vue-ttext{
        .ttext{
            position: absolute;
            top:0;
            left:0;
            right:0;
            bottom:0;
            height: 100%;
            width:100%;
            padding: 12px 15px;
        }
        .err{
            position: absolute;
            top:105%;
        }
        .num_wrap{
            position: absolute;
            top:105%;
            width:50%;
            right:0;
            text-align: right;
            font-size: 16px;
            color: $c_989;
            letter-spacing: -0.39px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/form/textarea.vue